import React, {useState, useEffect, useRef, useContext} from 'react';
import { useTranslation } from "react-i18next";
// import Serviced_vehicles from './Components/serviced_vehicles.js';
// import { Toast } from 'primereact/toast';
// import Loading from '../../Loading/loading';
// import { AuthContext } from "../../Header/auth - context";
// import { useSelector } from 'react-redux';
import { useSelector } from 'react-redux';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { TabMenu } from 'primereact/tabmenu';
import { AuthContext } from "../../../Header/auth - context";
import { confirmDialog } from 'primereact/confirmdialog';
import { ConfirmDialog } from 'primereact/confirmdialog'; // <- mora biti renderovana
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import handlePrintAcontation from '../stranaAkontacije/akontacijaStampa';
import CustomDropdown from '../../../custom/customDropdown';
import { Tooltip } from 'primereact/tooltip';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const BlagajnaAkontacijaUnos = () => {
  const { t } = useTranslation();

        const toast = useRef(null);
        const formRef = useRef(null);
        const auth = useContext(AuthContext);
        const company = useSelector(state => state.company)
        const eskaliran = useSelector(state => state.eskaliran)
        const role = useSelector(state => state.user_role)
        const trip = useSelector(state => state.trip)
        const user = useSelector(state => state.user)
        const [selectedRowIdAcontation , setSelectedRowIdAcontation] = useState(null);
        const isSelected = (row) => String(getIdAcontation(row)) === String(selectedRowIdAcontation);
        const [valutaOptions, setValutaOptions] = useState(null)
        const [trenutniSaldo, setTrenutniSaldo] = useState([])
        const [workersDB, setWorkersDB] = useState([])
        const [vrstaTransakcijeDB, setVrstaTransakcijeDB] = useState([])
        const [idWorker, setIdWorker] = useState(null)
        const [izabran, setIzabran] = useState(false)
        const [idAcontation, setIdAcontation] = useState(null)
        const [popuni, setPopuni] = useState(false)

        const [globalFilter, setGlobalFilter] = useState(null);
        const [first, setFirst] = useState(0);
        const [tableData, setTableData] = useState(null);
        const [allColumns, setAllColumns] = useState([]);
        const [selectedColumns, setSelectedColumns] = useState([]);
         const [originalColumnOrder, setOriginalColumnOrder] = useState([]);

        const [formSubmitted, setFormSubmitted] = useState(false);
        const getIdAcontation = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null;
        ///DATA

        const [formDataAcontacion, setFormDataAcontacion] = useState({
          brojAkontacije: '',
          id_vrsta_transakcije: null,
          datumPredaje: null,
          Iznos: null,
          Valuta: null,
          Napomena: ''
        });


    const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

    const popuniRedove = async (id) => {
  
        if(!id) {
             toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste izabrali akontaciju da bi popunili podatke!",
                        life: 3000,
                    });
        } else {
              let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/finance/FillInAcontationData", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  
                         
                                popuniStavke(data)
                                
                               toast.current.show({
                                severity: "success",
                                summary: "Uspešno popunjavanje podataka akontacije!",
                                life: 3000,
                                });
                              
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
        }
          
    }

  const popuniStavke = (apiData) => {

    setFormDataAcontacion({
        brojAkontacije: apiData[0].Broj || '',
        id_vrsta_transakcije: apiData[0].id_vrsta_transakcije || null,
        datumPredaje: apiData[0].datumPredaje ? new Date(apiData[0].datumPredaje) : null,
        Iznos: apiData[0].Iznos || null,
        Valuta: apiData[0].id_valuta || null,
        Napomena: apiData[0].Napomena || '',
      });
};

   useEffect(()=>{
    if(!formSubmitted){
                   let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  trip: null
                              }),
                          };
                          fetch(process.env.REACT_APP_BACKEND_URL + "/finance", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                                
                                const stringifiedJson = data[0][""];
                                const parsedData = JSON.parse(stringifiedJson);

                                setValutaOptions(parsedData.ValuteDB)
                                setTrenutniSaldo(parsedData.TrenutniStatus)
                                setWorkersDB(parsedData.WorkersDB)
                                setVrstaTransakcijeDB(parsedData.VrstaTrabsakcijeDB)

                                // if(data){
                                //    (data) 
                                // }
                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
                              
    }
      },[formSubmitted, idAcontation])



const resetData = ()=> {
    setFormDataAcontacion({
        brojAkontacije: '',
        id_vrsta_transakcije: null,
        datumPredaje: null,
        Iznos: null,
        Valuta: null,
        Napomena: ''
    })
}
const handleDeleteFuncAcontation = () => {
       
            confirmDialog({
            message: "Želite obrisati akontaciju?",
            acceptLabel: "Da",
            rejectLabel: "Ne",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: acceptDelete,
            reject: rejectDelete,
            });

    };

    const acceptDelete = async (id) => {
 
  let idValue;
  if(idAcontation == null && Number(id) != NaN)
    idValue = id
  else
    idValue = idAcontation
  if (Number(idValue)) {
     let requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          },
          body: JSON.stringify({
            id: idValue
          }),
        };
        
        fetch(process.env.REACT_APP_BACKEND_URL + "/finance/DeleteAcontacion", requestOptions)
          .then(handleErrors)
          .then((data) => {
            
             toast.current.show({
                severity: "success",
                summary: "Uspešna brisanje akontacije!",
                life: 3000,
                });
                resetData()
                setIdAcontation(null)
                setSelectedRowIdAcontation(null)
            fillDataTableForWorker(idWorker)
          })
          .catch((error) => {
            error.json().then((errorMessage) => {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: errorMessage.message,
                life: 3000,
              });
              console.log(errorMessage);
            });
          });
  } else {
        toast.current.show({
            severity: "warn",
            summary: "Niste izabrali akontaciju za štampu!",
            life: 3000,
            });
  }
   

  };
  const rejectDelete = () => {
    console.log("Odbijeno brisanje podataka!");
  }; 

    const handlePrintFuncAcontation = (id) => {
       
            confirmDialog({
            message: "Unos putnog naloga je završen. Štampa?",
            acceptLabel: "Da",
            rejectLabel: "Ne",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: ()=> acceptPrint(id),
            reject: rejectPrint,
            });

    };
 const acceptPrint = async (id) => {
  let idValue;
  if(idAcontation == null && Number(id) != NaN)
    idValue = id
  else
    idValue = idAcontation
  if (Number(idValue)) {
     let requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          },
          body: JSON.stringify({
            id: Number(idValue)
          }),
        };
        
        fetch(process.env.REACT_APP_BACKEND_URL + "/finance/printAcontation", requestOptions)
          .then(handleErrors)
          .then((data) => {
            if(data){
              handlePrintAcontation(data)
            } 
    
          })
          .catch((error) => {
            error.json().then((errorMessage) => {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: errorMessage.message,
                life: 3000,
              });
              console.log(errorMessage);
            });
          });
  } else {
        toast.current.show({
            severity: "warn",
            summary: "Niste izabrali akontaciju za štampu!",
            life: 3000,
            });
  }
   

  };
  const rejectPrint = () => {
    console.log("Odbijeno štampanje podataka!");
  };  

  function toUtcIso(d) {
    if (!d) return null;
    const x = d instanceof Date ? d : new Date(d);
    const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
    return utc.toISOString().slice(0, 19) + 'Z';
    }

   const handleFormSubmit = (e) => {
  
                       e.preventDefault(); // bitno da ne submituje bez validacije
                  setFormSubmitted(true)
              if (formRef.current && !formRef.current.checkValidity()) {
                  formRef.current.reportValidity(); // prikazuje native browser poruke
                  return;
              }
      handleUploadAndSave()
   }
          const handleUploadAndSave = () => {
         
              confirmDialog({
              message: "Jel ste sigurni da želite nastaviti sa unosom?",
              acceptLabel: "Da",
              rejectLabel: "Ne",
              icon: "pi pi-info-circle",
              acceptClassName: "p-button-danger",
              accept: acceptInsert,
              reject: rejectInsert,
              });
          
  
      };

      const acceptInsert = async () => {
  

              const val = trenutniSaldo.filter((x)=> x.IdValute == formDataAcontacion.Valuta)
               //doraditi izabran
               if (idAcontation) {

                let col = tableData.filter((x)=> x.Izaberi == idAcontation)
                
                let valuta = valutaOptions.filter((x)=> x.value == formDataAcontacion.Valuta)
                let suma;
        
                if(formDataAcontacion.Iznos > col[0].Iznos && valuta[0].label == col[0].Valuta) {
                  suma = formDataAcontacion.Iznos - col[0].Iznos
                    if(val[0].SumaKorigovana < suma && formDataAcontacion.id_vrsta_transakcije == 221) {
                      toast.current.show({
                                severity: "warn",
                                summary: "Nije moguće ažurirati transakciju jer nema dovoljno novca u kasi za " + val[0].Valuta + "!",
                                life: 3000,
                                });
                                return
                    }
                }
              } else {
                if (val[0].SumaKorigovana < formDataAcontacion.Iznos && formDataAcontacion.id_vrsta_transakcije == 221){
                  toast.current.show({
                                severity: "warn",
                                summary: "Nije moguće uneti transakciju jer nema dovoljno novca u kasi za " + val[0].Valuta + "!",
                                life: 3000,
                                });
                                return
                } 
              }
              //DATA
                  const hasAnyValueAcontation = Object.values(formDataAcontacion).some(value => {
                  if (value === null || value === '') return false;
  
                  // Check if it's a valid Date object
                  if (value instanceof Date && isNaN(value.getTime())) return false;
  
                  return true;
                  });
                  const payload = {
                        ...formDataAcontacion,
                        datumPredaje: toUtcIso(formDataAcontacion.datumPredaje)
                        };

                  if(izabran && idWorker && idAcontation){
                 if(hasAnyValueAcontation){                        
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: Number(idAcontation),
                                id_zaposleni: idWorker,
                                formDataAcontacion: payload
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/finance/UpdateAcontation", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                             
                               if(data){
                                    if(data[0].message && data[0].message != 'Nema izmena u podacima akontacije.' && data[0].message != 'Uspešna izmena!'){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data[0].message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                if(data[0].message == 'Nema izmena u podacima akontacije.'){
                                toast.current.show({
                                severity: "warn",
                                summary: data[0].message,
                                life: 3000,
                                });
                                
                               } else {
                                toast.current.show({
                                severity: "success",
                                summary: "Uspešna izmena podataka akontacije!",
                                life: 3000,
                                });
                               
                               }
                                setFormSubmitted(false)
                                
                                fillDataTableForWorker(idWorker)
                                setIdAcontation(null)
                                setSelectedRowIdAcontation(null)
                                if(data[0].ID) {
                                    handlePrintFuncAcontation(data[0].ID)
                                }
                                resetData()
                                } 
                                
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste popunili podatke akontacije!",
                        life: 3000,
                    });
                }
           
           
            } else {
                  if(hasAnyValueAcontation){
                      
                            let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                id_zaposleni: idWorker,
                                  formDataAcontacion: payload
                              }),
                          };
                          
                          await fetch(process.env.REACT_APP_BACKEND_URL + "/finance/InsertAcontacion", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                                   
                                  if(data.message === 'Nedostaju obavezna polja za unos akontacije.'){
                                      toast.current.show({
                                      severity: "error",
                                      summary: "Error",
                                      detail: data.message,
                                      life: 3000,
                                      });
                                      return
                                  } 
                                
                                  if(data[0].ID) {
                                    handlePrintFuncAcontation(data[0].ID)
                                }
                                  resetData()
                                  setFormSubmitted(false)
                                  fillDataTableForWorker(idWorker)
  
                                 toast.current.show({
                                  severity: "success",
                                  summary: "Uspešan unos podataka akontacije!",
                                  life: 3000,
                                  });

                                
                              //ubaciti deo da se forma ID za dalji unos
                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
                  } else {
                          toast.current.show({
                          severity: "warn",
                          summary: "Upozorenje!",
                          detail: "Niste popunili podatke akontacije za unos!",
                          life: 3000,
                      });
                  }
            }
  
    };
      const rejectInsert = () => {
      console.log("Odbijen unos podataka!");
    };     
  
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name in formDataAcontacion) {
        setFormDataAcontacion(prev => ({ ...prev, [name]: value }));
        }
    };
  
  
  const invalidControl = (data) => {
    if (!formSubmitted) return false; // ← NE prikazuj grešku dok forma nije poslata
  
    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };

  const fillDataTableForWorker = async (id) => {

           let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  id_zaposleni: id,
                                  trip: null
                              }),
                          };
                  
                          await fetch(process.env.REACT_APP_BACKEND_URL + "/finance/GetAcontacion", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                             
                                    setTableData(data)
                      
                                
                                  if (data && data.length > 0) {
                                                const columns = Object.keys(data[0])
                                                    .filter(key => !['ID'].includes(key))
                                                    .map(key => ({
                                                    label: key,
                                                    value: key
                                                    }));
                                        
                                                 
                                                setAllColumns(columns);
                                                  const originalOrder = Object.keys(data[0]);
                                                setOriginalColumnOrder(originalOrder);
                                                
                                                // Select first 5 columns by default (or adjust as needed)
                                                setSelectedColumns(columns.slice(0, 10).map(col => col.value));
                                                }

                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                            })

}

const selectIdWorkerFUNC = (e) => {

    if(e.target.value == undefined) {
        setIzabran(false);
        setTableData(null)
        resetData()
    } else {
        setIzabran(true);
    }  

    setIdWorker(e.target.value);
    fillDataTableForWorker(e.target.value)
    setPopuni(false)
    };

    const handleClickWorker = () => {
       if (idWorker) {  // resetuj samo ako ima vrednost
        setIdWorker(null);
        setIzabran(false);
        setTableData(null)
        setSelectedRowIdAcontation(null)
        setPopuni(false);
        resetData();
        setIdAcontation(null)
    }
}

  const exportExcel = async () => {
      if (!selectedColumns || selectedColumns.length === 0) return;
  
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Akontacija');
  
      // Use selectedColumns instead of all table keys
      const headers = selectedColumns;
  
      // Add header row
      const headerRow = worksheet.addRow(headers);
      headerRow.font = { bold: true };
      headerRow.eachCell((cell) => {
          cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFEFEFEF' }
          };
          cell.border = {
              top: { style: 'medium' },
              left: { style: 'medium' },
              bottom: { style: 'medium' },
              right: { style: 'medium' }
          };
      });
  
      // Add filtered data rows
      tableData.forEach((rowData) => {
          const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
          row.eachCell((cell) => {
              cell.border = {
                  top: { style: 'thin' },
                  left: { style: 'thin' },
                  bottom: { style: 'thin' },
                  right: { style: 'thin' }
              };
          });
      });
  
      // Auto-size columns
      worksheet.columns.forEach((column, i) => {
          const lengths = [
              headers[i].length,
              ...tableData.map(row => (row[headers[i]] ?? "").toString().length)
          ];
          column.width = Math.max(...lengths) + 2;
      });
  
      // Serbian-formatted datetime
      const date = new Date();
      const options = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'Europe/Belgrade'
      };
      const serbianDateTime = date.toLocaleString('sr-RS', options)
          .replace(/\s/g, ' ')
          .replace(/,/g, '');
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `Akontacija - ${company.companyName} - ${serbianDateTime}.xlsx`);
  };
       const header = (
          <div className="export-buttons fakture-stavke-header">
              <div className="fakture-stavke-radnje">
                <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
                {formDataAcontacion.id_vrsta_transakcije == 221 && <Button type="button" style={{marginLeft:'1%'}} icon="pi pi-print" severity="secondary" rounded onClick={handlePrintFuncAcontation} data-pr-tooltip="Print" />}
                {selectedRowIdAcontation && <Button type="button" style={{marginLeft:'1%'}} icon="pi pi-trash" severity="danger" rounded onClick={handleDeleteFuncAcontation} data-pr-tooltip="Print" />}
              </div>
          </div>
      );

     const isButtonColumn = (field) => {
    return field.startsWith('Izaberi') || 
           field.includes('File') || 
           field.includes('fajl') || 
           field.includes('upload') ||
           field.endsWith('LK') || // Lična karta
           field.endsWith('VD') || // Vozačka dozvola
           field.endsWith('PASS') || // Pasoš
           field.endsWith('VIZA') || // Viza
           field.includes('Dokument'); // Generic document
  };

    const chooseAcontation = (rowData) => {
      const id = getIdAcontation(rowData);

    setSelectedRowIdAcontation((prev) => {
      const next = String(prev) === String(id) ? null : String(id);

    if(next) {
       setIdAcontation(next)
      popuniRedove(id) 
      }
      else {
      setIdAcontation(null)
      resetData()
      }

    return next;
  });
 
  
}

     const previewBodyTemplateWork = (rowData, field) => {
      const filePathsString = rowData[field];
      if (!filePathsString) return '-';
     
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <Button
                label='Izaberi'
                icon="pi pi-eye"
                type="button"
                className="p-button-text p-button-sm"
                onClick={(e) => chooseAcontation(rowData)}
              />
            
        </div>
      );
    };

   return (
       <div style={{marginTop:"1%"}}> 
        <Toast ref={toast} />
        <div style={{marginLeft:"1%"}}>
            <div style={{display:'flex'}}><p style={{marginRight: '1%',marginBottom: '0', display:'flex', justifyContent: 'center', alignItems:'center'}}>Trenutni saldo:</p>{trenutniSaldo.map((item, i) => {
                            return (
                              <div key={i} style={{display:'flex', justifyContent: 'center', alignItems:'center', border: '1px solid rgb(224, 221, 221)', padding:'10px'}} >
                                <p style={{marginRight: '10px', marginBottom: '0',display:'flex', justifyContent: 'center', alignItems:'center'}} className={item.SumaKorigovana < 10 ? 'colorRed' : null}> <strong>{item.SumaKorigovana}</strong></p>
                                <p style={{marginRight: '10px', marginBottom: '0',display:'flex', justifyContent: 'center', alignItems:'center'}}><strong>[{item.Valuta}]</strong></p>
                              </div>
                            );
                          })}
            </div>
        </div>
        

        <ConfirmDialog />
              <div className="col-12"  style={{ borderBottom: '1px solid rgb(224, 221, 221)'}}>
                            
                            {(izabran) && <p class="infoPoruka" style={{marginTop:'1%'}}>Zaposleni je seletovan.</p>}
                              <div className="gridHeader" style={{marginTop:'1%'}}>
                                      <h4>{t('finansije.izborZaposlenog')}:</h4>
                                                 <CustomDropdown
                                                 style={{ width: "20%", marginLeft: '1%' }}
                                                 id="id_zaposleni" 
                                                 name="id_zaposleni" 
                                                 value={idWorker} 
                                                 options={workersDB || []}
                                                 placeholder={t('finansije.izaberiZaposlenog')}
                                                 optionLabel="label"
                                                 onChange={selectIdWorkerFUNC}
                                                 onFocus={handleClickWorker}  />

                            </div>
            </div>
            <div className='col-12 md:col-6'>
               <form autoComplete="off" ref={formRef} style={{marginTop:'1%'}}>
                          <div className='blagajnaDashboard'>
                             <Card>
                            <div className="gridLicni">
                              <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                                              <label htmlFor="brojAkontacije">{t('nova.broj')}:</label>
                                                              <InputText
                                                                  id="brojAkontacije" disabled 
                                                                  name="brojAkontacije" value={formDataAcontacion.brojAkontacije} inputStyle={{backgroundColor: '#efefef'}} 
                                                              />
                                                              
                                                          </div>
                                <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="Valuta">{t('ture.vrstaTransakcije')}:</label>
                                          <Dropdown 
                                                id="id_vrsta_transakcije" 
                                                name="id_vrsta_transakcije" 
                                                required
                                                invalid={invalidControl(formDataAcontacion.id_vrsta_transakcije)}
                                                value={formDataAcontacion.id_vrsta_transakcije} 
                                                options={vrstaTransakcijeDB || []} 
                                                onChange={handleChange}
                                                placeholder={t('ture.phTransakciju')}
                                            />
                              </div>
                              <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="Valuta">{t('ture.datumTransakcije')}:</label>
                                            <Calendar 
                                                id="datumPredaje"
                                                name="datumPredaje"
                                                required
                                                invalid={invalidControl(formDataAcontacion.datumPredaje)} 
                                                value={formDataAcontacion.datumPredaje} 
                                                onChange={handleChange}
                                                showIcon 
                                                dateFormat="dd.mm.yy" 
                                                mask="99.99.9999"
                                                />
                              </div>
                              <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="Iznos">{t('nova.iznos')}:</label>
                                 <InputNumber 
                                        id="Iznos" 
                                        name="Iznos" 
                                        required
                                        invalid={invalidControl(formDataAcontacion.Iznos)}
                                        value={formDataAcontacion.Iznos} 
                                        onValueChange={handleChange}
                                        minFractionDigits={2}
                                        maxFractionDigits={2}
                                        />
                              </div>

                              <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="Valuta">{t('nova.valuta')}:</label>
                                          <Dropdown 
                                                                    id="Valuta" 
                                                                    name="Valuta" 
                                                                    required={formDataAcontacion.Iznos == null ? false : true}
                                                                    invalid={formDataAcontacion.Iznos != null ? invalidControl(formDataAcontacion.Valuta) : null}
                                                                    value={formDataAcontacion.Valuta} 
                                                                    options={valutaOptions || []} 
                                                                    onChange={handleChange}
                                                                    placeholder={t('nova.phValutu')}
                                                                />
                              </div>
                              <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                    <label htmlFor="Napomena">{t('nova.napomena')}:</label>
                                    <InputText 
                                    id="Napomena" 
                                    name="Napomena" 
                                    value={formDataAcontacion.Napomena} 
                                    onChange={handleChange}
                                    />
                                </div>
                            </div>
                          </Card>
                          <Card>
                               <Tooltip target=".export-buttons>button" position="bottom" />
                                   <DataTable
                                          value={tableData || []}
                                          paginator
                                          rows={10}
                                          first={first}
                                          globalFilter={globalFilter}
                                          onPage={(e) => setFirst(e.first)}
                                          scrollable
                                          header={header}
                                          scrollHeight="15vh"
                                          emptyMessage={t('common.noDataTable')}
                                          resizableColumns
                                          className="turePregledTable stavke-tabela"
                                          columnResizeMode="expand"
                                          rowClassName={(data) => (isSelected(data) ? "selected-row" : "")}
                                        >
                                          {selectedColumns.map((colKey) => {
                                          const colMeta = allColumns.find(col => col.value === colKey);
                                          return (
                                            <Column
                                              key={colKey}
                                              field={colKey}
                                              header={colMeta?.label || colKey}
                                              sortable
                                              body={(rowData) => {
                                                if (isButtonColumn(colKey)) {
                                                  return previewBodyTemplateWork(rowData, colKey);
                                                }
                                                return rowData[colKey] || '-';
                                              }}
                                              style={{ minWidth: '150px'}}
                                            />
                                          );
                                        })}
                                    </DataTable>
                          </Card>
                          </div>
                    <div className="formUnosZap buttonUnosZap">
                      <button type="submit" onClick={handleFormSubmit} className="btn btn-success">
                        {idAcontation ? "SAČUVAJ" : "UNOS"}
                      </button>
                    </div>
                  </form>
            </div>                                

       </div>
   )
}
export default BlagajnaAkontacijaUnos;